import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Affix,
  Card,
  Group,
  ActionIcon,
  createStyles,
  Grid,
  Image,
  Text,
  Container,
  Anchor,
  rem,
  Center,
  Tooltip,
} from "@mantine/core";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";

import sampleData from "./stamps.json";
import { NotFoundPage } from "../../components/NotFoundPage";

const zeroPad = (num: number, places: number) => {
  return String(num).padStart(places, "0");
};
const minSampleId = 1;
const maxSampleId = Object.keys(sampleData).length;

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: rem(40),
    paddingBottom: rem(40),
  },

  card: {
    // height: "75vh",
    transition: "transform 150ms ease, box-shadow 150ms ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: theme.shadows.md,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    // fontWeight: 200,
  },

  hiddenMobile: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },
}));
function SampleDetailPage() {
  const { id } = useParams();
  const data = sampleData[id];
  const { classes } = useStyles();
  const currentNumericId = parseInt(id);
  const fileName = `https://vidyagiri.com/stamps/img/${id.toString()}.png`;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft" && currentNumericId > minSampleId) {
        window.location.href = `../stamp/${zeroPad(currentNumericId - 1, 3)}`;
      } else if (e.key === "ArrowRight" && currentNumericId < maxSampleId) {
        window.location.href = `../stamp/${zeroPad(currentNumericId + 1, 3)}`;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentNumericId]);
  return (
    <div>
      {data ? (
        <>
          <Container size="lg" className={classes.root}>
            <Grid>
              <Grid.Col sm={3}>
                <Anchor color="#9b9974" size="sm" href="../stamps">
                  ← back to all stamps
                </Anchor>
                <br />
                <br />

                <Text size={20} className={classes.title}>
                  [{id}]
                </Text>

                <Text size={35} transform="lowercase">
                  {data.country}
                </Text>
                <br />
                <Text size="md">{data.description}</Text>
                <br />

                <Group mt={30}>
                  {data.link1 || data.link2 || data.link3 ? (
                    <>
                      <Text size="sm" italic>
                        {data.link1 && !data.link2 && !data.link3
                          ? "reference"
                          : "references"}
                      </Text>
                      {data.link1 && (
                        <Text size="sm">
                          <a
                            target="_blank"
                            href={data.link1}
                            rel="noopener noreferrer"
                          >
                            i
                          </a>
                        </Text>
                      )}
                      {data.link2 && (
                        <Text size="sm">
                          <a
                            target="_blank"
                            href={data.link2}
                            rel="noopener noreferrer"
                          >
                            ii
                          </a>
                        </Text>
                      )}
                      {data.link3 && (
                        <Text size="sm">
                          <a
                            target="_blank"
                            href={data.link3}
                            rel="noopener noreferrer"
                          >
                            iii
                          </a>
                        </Text>
                      )}
                    </>
                  ) : null}
                </Group>
              </Grid.Col>
              <Grid.Col sm={1}>
                {currentNumericId > minSampleId ? (
                  <Center
                    className={classes.hiddenMobile}
                    maw={400}
                    h={"100%"}
                    mx="auto"
                  >
                    <Tooltip.Floating label="previous stamp">
                      <ActionIcon
                        component="a"
                        href={"../stamp/" + zeroPad(currentNumericId - 1, 3)}
                      >
                        <IconChevronLeft color="#9b9974" size={rem(30)} />
                      </ActionIcon>
                    </Tooltip.Floating>
                  </Center>
                ) : (
                  <></>
                )}
              </Grid.Col>
              <Grid.Col sm={4.5}>
                {/* <Tooltip.Floating label={data.description}> */}
                <Card
                  key={id}
                  p="md"
                  radius="md"
                  component="a"
                  target="blank"
                  className={classes.card}
                >
                  <Image src={fileName} />
                </Card>

                {/* </Tooltip.Floating> */}

                {/* </Card> */}
              </Grid.Col>
              <Grid.Col sm={1}>
                {currentNumericId < maxSampleId ? (
                  <Center
                    className={classes.hiddenMobile}
                    maw={400}
                    h={"100%"}
                    mx="auto"
                  >
                    <Tooltip.Floating label="next stamp">
                      <ActionIcon
                        component="a"
                        href={"../stamp/" + zeroPad(currentNumericId + 1, 3)}
                      >
                        <IconChevronRight color="#9b9974" size={rem(30)} />
                      </ActionIcon>
                    </Tooltip.Floating>
                  </Center>
                ) : (
                  <></>
                )}
              </Grid.Col>
            </Grid>
          </Container>
          {currentNumericId > minSampleId ? (
            <Affix
              className={classes.hiddenDesktop}
              position={{ top: rem(450), left: rem(20) }}
            >
              <Tooltip label="previous stamp">
                <ActionIcon
                  variant="default"
                  radius="xl"
                  component="a"
                  href={"../stamp/" + zeroPad(currentNumericId - 1, 3)}
                >
                  <IconChevronLeft size={rem(30)} />
                </ActionIcon>
              </Tooltip>
            </Affix>
          ) : (
            <></>
          )}
          {currentNumericId < maxSampleId ? (
            <Affix
              className={classes.hiddenDesktop}
              position={{ top: rem(450), right: rem(20) }}
            >
              <Tooltip label="next stamp">
                <ActionIcon
                  variant="default"
                  radius="xl"
                  component="a"
                  href={"../stamp/" + zeroPad(currentNumericId + 1, 3)}
                >
                  <IconChevronRight size={rem(30)} />
                </ActionIcon>
              </Tooltip>
            </Affix>
          ) : (
            <></>
          )}
        </>
      ) : (
        <NotFoundPage />
      )}
    </div>
  );
}
export default SampleDetailPage;
